// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/generative_ai/agent/:id/logs" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { generativeAiAgentIdLogs } from "./constants";
import type { GenerativeAiAgentIdLogsParams, GenerativeAiAgentIdLogsResult } from "./types";
import { isGenerativeAiAgentIdLogsResult } from "./validators";

export const getDataTableGenerativeAiAgentIdLogs = reactQueryTableFetcherAdapter(
  generativeAiAgentIdLogs,
  (
    signal: AbortSignal,
    {
      appGroupId,
      id,
      query = {},
      search_term,
      groupby,
      limit = 20,
      start = 0,
      sortdir,
      sortby,
      is_error,
      calling_location,
      start_date,
      end_date,
    }: GenerativeAiAgentIdLogsParams
  ): Promise<GenerativeAiAgentIdLogsResult> => {
    return fetch(
      `/generative_ai/agent/${id}/logs`,
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        query: serializeQueryObjects(query),
        search_term,
        is_error,
        calling_location,
        start_date,
        end_date,
      },
      { signal }
    );
  },
  isGenerativeAiAgentIdLogsResult
);
